<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Edit business details </h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>

   

      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Enter business name" [(ngModel)]="entityDetails.entityName"/>
      </mat-form-field>


      <!-- <mat-form-field appearance="outline">
        <mat-label>Phone</mat-label>
        <input smNumericOnly type="tel" maxlength="10" matInput placeholder="Enter Phone" [(ngModel)]="entityDetails.entityPhone"/>
      </mat-form-field> -->

      <div class="c_sectionmj">
        <div class="form-container add-bottom-margin">
        <div class="row">
         <div class="col-sm-4">
          <mat-form-field appearance="outline" class="country-code">
            <mat-label>Country Code</mat-label>
            <mat-select
            [(ngModel)]="entityCountryCode"
            required
            (selectionChange)="onCountrySelected($event)"
          >
            <mat-select-trigger>
              {{ entityCountryCode.flag }} {{ entityCountryCode.name }}
                  {{ "(" + entityCountryCode.dial_code + ")" }}
            </mat-select-trigger>
            
            <mat-option>
              <ngx-mat-select-search
                noEntriesFoundLabel="no results found"
                name="countrysearch"
                placeholderLabel="Enter country name"
                [formControl]="searchString"
                (keyup)="onKey()"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let country of countryList" [value]="country">
              {{ country.flag }} {{ country.name }}
              {{ "(" + country.dial_code + ")" }}
            </mat-option>
          </mat-select>
          </mat-form-field>
       </div>
       <div class="col-sm-8">
         <mat-form-field appearance="outline" class="phone-number">
           <mat-label>Phone</mat-label>
           <input  smNumericOnly
           minLength="3"
                  maxlength="17"
           type="tel"
           [(ngModel)]="entityDetails.entityPhone"
           placeholder="Enter phone number
           "
             matInput
             #input>
         </mat-form-field>
         </div>
       </div>
       </div>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea  [maxLength]="1000" matInput placeholder="Enter description" [(ngModel)]="entityDetails.entityDesc"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email (optional)</mat-label>
        <input matInput placeholder="Enter email" [(ngModel)]="entityDetails.entity_email"/>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Business website (optional)</mat-label>
        <input matInput placeholder="Enter website address" [(ngModel)]="entityDetails.business_website_address"/>
      </mat-form-field>

   

      <mat-form-field appearance="outline" >
        <mat-label>Owner name</mat-label>
        <input matInput placeholder="Enter Owner name" [(ngModel)]="entityDetails.ownerName"/>
      </mat-form-field>
<!-- 
      <mat-form-field appearance="outline" >
        <mat-label>Owner phone</mat-label>
        <input smNumericOnly type="tel" maxlength="10" matInput placeholder="Enter owner phone" [(ngModel)]="entityDetails.ownerPhone"/>
      </mat-form-field> -->


      <div class="c_sectionmj">
        <div class="form-container add-bottom-margin">
        <div class="row">
         <div class="col-sm-4">
          <mat-form-field appearance="outline" class="country-code">
            <mat-label>Country Code</mat-label>
            <mat-select
            [(ngModel)]="ownerCountryCode"
            required
            (selectionChange)="onCountrySelected($event)"
          >
            <mat-select-trigger>
              {{ ownerCountryCode.flag }} {{ ownerCountryCode.name }}
                  {{ "(" + ownerCountryCode.dial_code + ")" }}
            </mat-select-trigger>
            
            <mat-option>
              <ngx-mat-select-search
                noEntriesFoundLabel="no results found"
                name="countrysearch"
                placeholderLabel="Enter country name"
                [formControl]="searchString"
                (keyup)="onKey()"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let country of countryList" [value]="country">
              {{ country.flag }} {{ country.name }}
              {{ "(" + country.dial_code + ")" }}
            </mat-option>
          </mat-select>
          </mat-form-field>
       </div>
       <div class="col-sm-8">
         <mat-form-field appearance="outline" class="phone-number">
           <mat-label>Owner phone</mat-label>
           <input  smNumericOnly
           maxlength="10"
           type="tel"
           [(ngModel)]="entityDetails.ownerPhone"
           placeholder="Enter owner phone
           "
             matInput
             #input>
         </mat-form-field>
         </div>
       </div>
       </div>
      </div>





      <mat-form-field appearance="outline" >
        <mat-label>Registration number</mat-label>
        <input matInput placeholder="Enter registration number" [(ngModel)]="entityDetails.referenceNo"/>
      </mat-form-field>
      <mat-form-field appearance="outline" >
        <mat-label>Registration type</mat-label>
        <input matInput placeholder="The type of registration"/>
      </mat-form-field>


   



    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button
          mat-flat-button
          [disabled]="checkForm()"
          (click)="onSave()"
          color="accent">
        Save
        </button>
      </mat-dialog-actions>